export { OverlaysLegends } from './OverlaysLegends.component';
